@if (node) {
  <div class="toc-node-details-in-node">
    @if ((layer?.description || node.metadata?.description); as description) {
      <div class="toc-node-description"><tm-htmlify [text]="description" /></div>
    }
    @if (node.metadata?.id) {
      <div class="toc-node-details-transparency">
        <tm-layer-transparency [layer]="node.metadata.id"></tm-layer-transparency>
      </div>
    }
  </div>
}
